import {
  createLabelItems,
  getEligibleItems,
  getEligibleItemsByReturnDate,
  getIneligibleItems,
} from '../../../services/order-info/utils';

export const getNonNullShipment = ({ shipmentList = [] }) => {
  const now = new Date();
  return shipmentList.filter(({ ship_by_date: shipByDate }) => {
    const shipDate = new Date(shipByDate);
    now.setHours(0, 0, 0, 0);
    shipDate.setHours(0, 0, 0, 0);

    const diffTime = shipDate - now;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays >= 0;
  });
};

export const getNaItems = ({ allItems, retailerEligibilities, ignoreReturnLabels }) =>
  getIneligibleItems(allItems, retailerEligibilities).filter(
    (item) => item.remaining_qty > 0 || ignoreReturnLabels,
  );

export const getReturnCollection = ({
  ignoreReturnLabels,
  allOrders,
  retailerEligibilities,
  language,
  locale,
  exchangeEnabled,
  claimsEnabled,
}) =>
  allOrders.map((order) => {
    const allItems = order.order_info_items;
    const nonNullShipmentList = getNonNullShipment({ shipmentList: order.shipments_list });
    const {
      byDay,
      byTimestamp,
      ineligibleByDay = [],
    } = getEligibleItemsByReturnDate(
      allItems,
      nonNullShipmentList,
      retailerEligibilities,
      language,
      locale,
      exchangeEnabled,
    );

    const naItems = getNaItems({ allItems, retailerEligibilities, ignoreReturnLabels });

    const items = getEligibleItems(
      allItems,
      retailerEligibilities,
      exchangeEnabled || claimsEnabled ? 'some' : 'every',
    );

    const { return_labels: returnLabels = [] } = order.order_info;

    createLabelItems({
      labels: returnLabels,
      retailerName: order.order_info.retailer,
      allItems,
    });

    return {
      byDay,
      byTimestamp,
      ineligibleByDay,
      allItems,
      naItems,
      items,
      returnLabels: returnLabels.map((label) => ({
        ...label,
        order_number: order.order_info.order_number,
      })),
    };
  });

const quantityMutations = (item, { key }) =>
  item[key]
    ? {
        ...item,
        item_properties: item.item_properties
          ? item.item_properties.map((property) =>
              property.key === 'Quantity' ? { ...property, value: `${item[key]}` } : property,
            )
          : [],
      }
    : item;

const mutationTypes = {
  quantity: quantityMutations,
};

export const mutations = ({ items, mutationConfigs }) => {
  if (!items) return [];
  if (!mutationConfigs) return items;
  return mutationConfigs.reduce(
    (acc, { type, ...props }) =>
      mutationTypes[type] ? items.map((item) => mutationTypes[type](item, props)) : items,
    [],
  );
};
